import React from "react";
import customerSupportImg from '../assets/images/CustomerSupport.png';
import secureStayImg from '../assets/images/secureStay.jpg';
import hassleFreeImg from '../assets/images/hassle-free.jpg';

const features = [
    {
        title: "Hassle-Free Stay",
        description:
            "Enjoy a hassle-free living experience with Zoy! Simplified bookings, smooth check-ins, and effortless stays—because your comfort is our priority.",
        image: secureStayImg,
    },
    {
        title: "Responsive Support Team",
        description:
            "Our responsive support team is here for you 24/7! Get quick assistance and seamless resolutions for a worry-free stay.",
        image: customerSupportImg,
    },
    {
        title: "Secure Stay",
        description:
            "Enjoy a safe and secure stay with Zoy. Our PGs are verified, ensuring a comfortable and worry-free living experience.",
        image: hassleFreeImg,
    },
];

const FeatureSection = () => {
    return (
        <div className="container mx-auto px-6 py-12">
            <div className="grid md:grid-cols-3 gap-8">
                {features.map((feature, index) => (
                    <div
                        key={index}
                        className="bg-white rounded-lg shadow-lg overflow-hidden"
                    >
                        <img
                            src={feature.image}
                            alt={feature.title}
                            className="w-full h-64 object-cover"
                        />
                        <div className="p-6 text-center">
                            <h3 className="text-xl font-bold text-pink-500">{feature.title}</h3>
                            <p className="text-gray-600 mt-2">{feature.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FeatureSection;
